/**
 * Matches emoji and emoji-like Unicode characters along with surrounding whitespace.
 *
 * Character groups targeted:
 *   - [\uD800-\uDBFF][\uDC00-\uDFFF] : Surrogate pairs (most standard emoji, e.g. 😀)
 *   - [\u2000-\u3300]                 : Misc symbols, arrows, CJK, Hiragana/Katakana blocks
 *   - [\u200D\uFE0F]                  : Zero-width joiner & variation selector (compound emoji, e.g. 👨‍👩‍👧)
 *
 */
export const EMOJI_REGEX = /([\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2000-\u3300]|[\u200D\uFE0F])/g;

export function sanitizeInput(value?: string | null, replaceWith: string = ' '): string | null | undefined {
  if (!value) {
    return value;
  }
  EMOJI_REGEX.lastIndex = 0;
  if (!EMOJI_REGEX.test(value)) {
    return value;
  }

  EMOJI_REGEX.lastIndex = 0;

  return value.replace(EMOJI_REGEX, replaceWith).trim();
}

export function sanitizeAllInputs<T extends Record<string, unknown>>(obj: T): T {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, typeof value === 'string' ? sanitizeInput(value) : value])
  ) as T;
}
